module.exports = __webpack_public_path__ + "img/horizontal_3_5_8004.5f0f64b4.png";